import { IMultipleIdsParams } from '../types/actionParams';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class RunSchedulesRequest extends Request<IMultipleIdsParams, IResult> {
  constructor(ids: string[]) {
    super('runSchedules', {
      ids: ids
    });
  }
}
